import * as Dayjs from 'dayjs'
import Helper from './helper'

//noinspection JSUnusedGlobalSymbols
export default class Is
{
	static bool(value:any, numeric = false):boolean
	{
		return numeric ? !!Helper.string(value).match(/^[01]$/) : typeof value === 'boolean'
	}

	static int(value:any, zero = true):boolean
	{
		const pattern = /^-?\d+$/

		if(typeof value !== 'string' && typeof value !== 'number' || !Helper.string(value).match(pattern)) return false
		return !zero && Number(value) === 0 ? false : !!Helper.string(value).match(pattern)
	}

	static float(value:any, zero = true):boolean
	{
		const pattern = /^-?\d+(\.\d+)?$/

		if(typeof value !== 'string' && typeof value !== 'number' || !Helper.string(value).match(pattern)) return false
		return !zero && Number(value) === 0 ? false : !!Helper.string(value).match(pattern)
	}

	static filled(value:any):boolean
	{
		return ['number', 'string'].includes(typeof value) && !Helper.string(value).match(/^[　\s]*$/)
	}

	static date(value:any):boolean
	{
		if(typeof value !== 'string') return false
		return !!value.match(/^\d+-\d+-\d+$/) && Dayjs(value).isValid()
	}

	static datetime(value:any):boolean
	{
		if(typeof value !== 'string') return false
		return !!value.match(/^\d+-\d+-\d+ \d+:\d+:\d+$/) && Dayjs(value).isValid()
	}

	static time(value:any):boolean
	{
		if(typeof value !== 'string') return false
		return !!value.match(/^\d+:\d+$/) && Dayjs(`2000-01-01 ${value}`).isValid()
	}

	static email(value:any):boolean
	{
		if(typeof value !== 'string') return false

		//https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Input/email#Validation
		return !!value.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/)
	}

	static object(value:any):boolean
	{
		return typeof value === 'object' && value !== null
	}
}
